//import { EntityContext } from '@app/collections/fortress/EntityContext'
//import { ProfileContext } from '@app/collections/fortress/ProfileContext'
import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Button, Description, DescriptionItem, Link, Row } from '@app/components'
//import { IStore } from '@app/redux'
//import { auth } from '@app/services'
import { Col } from 'antd'
//import axios from 'axios'
//import { isEmpty } from 'lodash'
import React, { useContext, useEffect, useRef, useState } from 'react'
//import { useSelector } from 'react-redux'

export const RevolutTransferContent: React.FC<any> = ({ /*setCurrentNode,*/ userMemo }) => {
  //const { user } = useSelector((state: IStore) => state)
  const componentRef = useRef()
  const { fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    fetchUserInfo()
  }, [])

  const [bankDetails, setBankDetails] = useState({
    accountNumber: '',
    routingNumber: '',
    recipientName: '',
    recipientAddress: '',
    bankName: '',
    memo: '',
  })
  // Function to get bank details based on the last character of userMemo
  const getBankDetails = (userMemo: string) => {
    const lastChar = userMemo.slice(-1) // Get the last character of userMemo

    if (userMemo) {
      if (/[A-M]/.test(lastChar)) {
        // Last character is a-z
        return {
          //PNC Bank Details
          accountNumber: '4698968264',
          routingNumber: '043000096',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'PNC Bank',
          memo: userMemo,
        }
      } else if (/[0-9]/.test(lastChar)) {
        // Last character is 0-9
        return {
          //Chase Bank Details
          accountNumber: '2901988958',
          routingNumber: '111000614',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'Chase Bank',
          memo: userMemo,
        }
      } else if (/[N-Z]/.test(lastChar)) {
        // Last character is N-Z
        return {
          //Wells Fargo Bank Details
          accountNumber: '7729151519',
          routingNumber: '121000248',
          //Update Address
          recipientName: 'CTS Global',
          recipientAddress: '1001 S. Main St, Kalispell, Montana, 59901',
          bankName: 'Wells Fargo Bank',
          memo: userMemo,
        }
      }
    } else {
      // Default or invalid character handling
      return {
        accountNumber: '',
        routingNumber: '',
        recipientName: '',
        recipientAddress: '',
        bankName: '',
        memo: '',
      }
    }
  }

  // Get the bank details based on userMemo
  useEffect(() => {
    const tmpDetails = getBankDetails(userMemo)
    //console.log(bankDetails);
    setBankDetails(tmpDetails)
  }, [userMemo])

  return (
    <Row gutter={[30, 30]}>
      <Col span={24} ref={componentRef}>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <>
              <Description column={1}>
                <DescriptionItem label="Create Account">
                  <Link href={'https://www.revolut.com/'} target="_blank">
                    revolut.com
                  </Link>
                </DescriptionItem>
                <DescriptionItem label="Routing Number">{bankDetails.routingNumber}</DescriptionItem>
                <DescriptionItem label="Account Number">{bankDetails.accountNumber}</DescriptionItem>
                <DescriptionItem label="Recipient Name">{bankDetails.recipientName}</DescriptionItem>
                <DescriptionItem label="Recipient Address">{bankDetails.recipientAddress}</DescriptionItem>
                <DescriptionItem label="Memo/Reference (Required)">{bankDetails.memo}</DescriptionItem>
                <DescriptionItem label="Email">{'info@ctsglobal.io'}</DescriptionItem>
              </Description>

              <Row>
                <Col span={24}>
                  <Button
                    block
                    style={{ backgroundColor: '#FFFFFF', color: '#2d54a4', borderColor: '#2d54a4' }}
                    href="https://intercom.help/0xcoast/en/articles/8399859-funding-your-coast-account-with-revolut-com-international"
                    target="_blank"
                  >
                    Deposit Instructions
                  </Button>
                </Col>
                {/*<Col span={12}>
                    <Button block href="https://www.revolut.com/payments/" target="_blank">
                      Start a Deposit
                    </Button>
                    </Col>*/}
              </Row>
            </>
          </Col>

          {/*<Col>
            <Button type="default" icon={<DownloadOutlined />} onClick={handleImageSave}>
              Download
            </Button>
            </Col>*/}
        </Row>
      </Col>
    </Row>
  )
}
